const commonTableFields = [
  {
    i18n: "device.code",
    dataIndex: "device.code",
    width: 145,
    searchType: "input",
    reachField: "deviceCode",
    linked: true,
    linkAuthoritation: "deviceUpdatable",
    routeFunctionName: "goToDevice",
    loadingField: "codeLoading"
  },
  {
    i18n: "customer.company",
    dataIndex: "customer.company",
    width: 210,
    searchType: "input",
    reachField: "customerCompany",
    linked: true,
    linkAuthoritation: "customerUpdatable",
    routeFunctionName: "goToCustomer"
  },
  {
    i18n: "warning.warningStatus",
    dataIndex: "warningStatus",
    width: 110,
    searchType: "select",
    selectOptionsField: "warningStatuses",
    reachField: "warningStatus"
  },
  {
    i18n: "device.warningTag",
    dataIndex: "device.tag",
    width: 150,
    searchType: "select",
    selectOptionsField: "warningTags",
    reachField: "deviceTag",
    dropdownClass: "tableWarningTagOption"
  },
  {
    i18n: "history.machineType",
    dataIndex: "device.model",
    width: 150,
    searchType: "input",
    reachField: "deviceModel"
  },
  {
    i18n: "common.power",
    dataIndex: "device.power",
    width: 150,
    searchType: "multipies",
    selectOptionsField: "judgeTypes",
    reachField: "devicePower"
  },
  {
    i18n: "warning.saleOrg",
    dataIndex: "salesmen.organizationName",
    width: 180,
    searchType: "input",
    reachField: "organizationNamesOfSalesMen"
  },
  {
    i18n: "common.salesMen",
    dataIndex: "salesmen.realName",
    width: 100,
    searchType: "input",
    reachField: "namesOfSalesMen"
  },
  {
    i18n: "warning.salesRole",
    dataIndex: "salesmen.roleName",
    width: 120,
    searchType: "input",
    reachField: "roleNamesOfSalesMen"
  },
  {
    i18n: "warning.serviceOrg",
    dataIndex: "serviceMans.organizationName",
    width: 180,
    searchType: "input",
    reachField: "organizationNamesOfServiceMen"
  },
  {
    i18n: "warning.serviceName",
    dataIndex: "serviceMans.realName",
    width: 100,
    searchType: "input",
    reachField: "namesOfServiceMen"
  },
  {
    i18n: "warning.serviceRole",
    dataIndex: "serviceMans.roleName",
    width: 120,
    searchType: "input",
    reachField: "roleNamesOfServiceMen"
  }
]

const commonQueryParams = {}

const commonHighlightInfo = {}

const commonFilterParams = {}

const commonMultipieFilterParams = {}

let c
for (let i = 0; i < commonTableFields.length; i++) {
  c = commonTableFields[i]

  if (c.searchType === "input") {
    commonQueryParams[c.dataIndex] = ""
  }

  if (c.searchType === "select") {
    commonFilterParams[c.dataIndex] = ""
  }

  if (c.searchType === "multipies") {
    commonMultipieFilterParams[c.dataIndex] = {
      req: "",
      value: ""
    }
  }
}

for (let key in commonQueryParams) {
  commonHighlightInfo[key] = ""
}

const privateColumns = {
  MAINTAIN: [
    {
      i18n: "warning.leaveDays",
      dataIndex: "leaveDays",
      searchType: "leaveTime",
      width: 100,
      reachField: "leaveDays"
    },
    {
      i18n: "warning.leaveHours",
      dataIndex: "leaveHours",
      searchType: "leaveTime",
      width: 100,
      reachField: "leaveHours"
    },
    {
      i18n: "warning.runTime",
      dataIndex: "runTime",
      searchType: null,
      width: 130,
      reachField: "runTime"
    },
    {
      i18n: "warning.maintainTime",
      dataIndex: "maintainTime",
      searchType: null,
      width: 130,
      reachField: "maintainTime"
    },
    {
      i18n: "warning.lastMaintainTime",
      dataIndex: "lastMaintainTime",
      searchType: null,
      width: 170,
      reachField: "deviceLastMaintainTime"
    },
    {
      i18n: "warning.registerTime",
      dataIndex: "registerTime",
      searchType: null,
      width: 170,
      reachField: "registerTime"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 170,
      reachField: "createdAt"
    }
  ],
  AIR_INSUFFICIENCY: [
    {
      i18n: "warning.avgPressure",
      dataIndex: "avgPressure",
      searchType: null,
      width: 120,
      reachField: "avgPressure"
    },
    {
      i18n: "warning.ratedPressure",
      dataIndex: "ratedPressure",
      searchType: null,
      width: 120,
      reachField: "ratedPressure"
    },
    {
      i18n: "warning.avgFrequency",
      dataIndex: "avgFrequency",
      searchType: null,
      width: 110,
      reachField: "avgFrequency"
    },
    {
      i18n: "warning.ratedFrequency",
      dataIndex: "ratedFrequency",
      searchType: null,
      width: 110,
      reachField: "ratedFrequency"
    },
    {
      i18n: "warning.avgTemperature",
      dataIndex: "avgTemperature",
      searchType: null,
      width: 110,
      reachField: "avgTemperature"
    },
    {
      i18n: "warning.percentage_air",
      dataIndex: "percentage",
      searchType: null,
      width: 90,
      reachField: "percentage"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  HIGH_TEMPERATURE: [
    {
      i18n: "warning.avgCurrent",
      dataIndex: "avgCurrent",
      searchType: null,
      width: 105,
      reachField: "avgCurrent"
    },
    {
      i18n: "warning.fanTemperature",
      dataIndex: "fanTemperature",
      searchType: null,
      width: 110,
      reachField: "fanTemperature"
    },
    {
      i18n: "warning.avgTemperature",
      dataIndex: "avgTemperature",
      searchType: null,
      width: 110,
      reachField: "avgTemperature"
    },
    {
      i18n: "warning.ratedTemperature",
      dataIndex: "ratedTemperature",
      searchType: null,
      width: 110,
      reachField: "ratedTemperature"
    },
    {
      i18n: "warning.percentage_heat",
      dataIndex: "percentage",
      searchType: null,
      width: 70,
      reachField: "percentage"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  OVER_CURRENT: [
    {
      i18n: "warning.avgCurrent",
      dataIndex: "avgCurrent",
      searchType: null,
      width: 95,
      reachField: "avgCurrent"
    },
    {
      i18n: "warning.ratedCurrent",
      dataIndex: "ratedCurrent",
      searchType: null,
      width: 95,
      reachField: "ratedCurrent"
    },
    {
      i18n: "warning.percentage_overflowing",
      dataIndex: "percentage",
      searchType: null,
      width: 70,
      reachField: "percentage"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  LOW_FREQUENCY: [
    {
      i18n: "warning.avgPressure",
      dataIndex: "avgPressure",
      searchType: null,
      width: 120,
      reachField: "avgPressure"
    },
    {
      i18n: "warning.avgTemperature",
      dataIndex: "avgTemperature",
      searchType: null,
      width: 100,
      reachField: "avgTemperature"
    },
    {
      i18n: "warning.avgFrequency",
      dataIndex: "avgFrequency",
      searchType: null,
      width: 110,
      reachField: "avgFrequency"
    },
    {
      i18n: "warning.ratedPressure",
      dataIndex: "ratedPressure",
      searchType: null,
      width: 120,
      reachField: "ratedPressure"
    },
    {
      i18n: "warning.ratedFrequency",
      dataIndex: "upperLimitFrequency",
      searchType: null,
      width: 105,
      reachField: "upperLimitFrequency"
    },
    {
      i18n: "warning.lowerLimitFrequency",
      dataIndex: "lowerLimitFrequency",
      searchType: null,
      width: 105,
      reachField: "lowerLimitFrequency"
    },
    {
      i18n: "warning.percentage_low",
      dataIndex: "percentage",
      searchType: null,
      width: 70,
      reachField: "percentage"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  INVERTER_HIGH_TEMPERATURE: [
    {
      i18n: "warning.avgFrequency",
      dataIndex: "avgFrequency",
      searchType: null,
      width: 120,
      reachField: "avgFrequency"
    },
    {
      i18n: "warning.inverterTemperature",
      dataIndex: "inverterTemperature",
      searchType: null,
      width: 100,
      reachField: "inverterTemperature"
    },
    {
      i18n: "warning.avgCurrent",
      dataIndex: "avgCurrent",
      searchType: null,
      width: 110,
      reachField: "avgCurrent"
    },
    {
      i18n: "warning.percentage_heat",
      dataIndex: "percentage",
      searchType: null,
      width: 70,
      reachField: "percentage"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  AIR_FILTER_BLOCKED: [
    {
      i18n: "warning.conversionRatedPower",
      dataIndex: "conversionRatedPower",
      searchType: null,
      width: 150,
      reachField: "conversionRatedPower"
    },
    {
      i18n: "warning.ratedPower",
      dataIndex: "ratedPower",
      searchType: null,
      width: 110,
      reachField: "ratedPower"
    },
    {
      i18n: "warning.percentage_block",
      dataIndex: "percentage",
      searchType: null,
      width: 70,
      reachField: "percentage"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  OVERLOAD: [
    {
      i18n: "warning.conversionRatedPower",
      dataIndex: "conversionRatedPower",
      searchType: null,
      width: 150,
      reachField: "conversionRatedPower"
    },
    {
      i18n: "warning.ratedPower",
      dataIndex: "ratedPower",
      searchType: null,
      width: 110,
      reachField: "ratedPower"
    },
    {
      i18n: "warning.percentage_overload",
      dataIndex: "percentage",
      searchType: null,
      width: 70,
      reachField: "percentage"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  INSPECTION: [
    {
      i18n: "warning.runTime",
      dataIndex: "runTime",
      searchType: null,
      width: 100,
      reachField: "runTime"
    },
    {
      i18n: "warning.maintainTime",
      dataIndex: "maintainTime",
      searchType: null,
      width: 100,
      reachField: "maintainTime"
    },
    {
      i18n: "warning.maintainTimeSetting",
      dataIndex: "maintainTimeSetting",
      searchType: null,
      width: 130,
      reachField: "maintainTimeSetting"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  ERROR: [
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 160,
      reachField: "createdAt"
    },
    {
      i18n: "warning.errorNo",
      dataIndex: "errorNo",
      searchType: null,
      width: 100,
      reachField: "errorNo"
    },
    {
      i18n: "warning.eelectric",
      dataIndex: "eelectric",
      searchType: null,
      width: 80,
      reachField: "eelectric"
    },
    {
      i18n: "warning.etime",
      dataIndex: "etime",
      searchType: null,
      width: 80,
      reachField: "etime"
    },
    {
      i18n: "warning.etemperature",
      dataIndex: "etemperature",
      searchType: null,
      width: 80,
      reachField: "etemperature"
    },
    {
      i18n: "warning.ebus",
      dataIndex: "ebus",
      searchType: null,
      width: 80,
      reachField: "ebus"
    },
    {
      i18n: "warning.efrequency",
      dataIndex: "efrequency",
      searchType: null,
      width: 80,
      reachField: "efrequency"
    },
    {
      i18n: "warning.epressure",
      dataIndex: "epressure",
      searchType: null,
      width: 80,
      reachField: "epressure"
    },
    {
      i18n: "warning.eoutputVoltage",
      dataIndex: "eoutputVoltage",
      searchType: null,
      width: 110,
      reachField: "eoutputVoltage"
    },
    {
      i18n: "warning.eio",
      dataIndex: "eio",
      searchType: null,
      width: 100,
      reachField: "eio"
    }
  ],
  LOW_APPLY_PRESSURE: [
    {
      i18n: "warning.exhaustPressure",
      dataIndex: "exhaustPressure",
      searchType: null,
      width: 120,
      reachField: "exhaustPressure"
    },
    {
      i18n: "warning.exhaustTemperature",
      dataIndex: "exhaustTemperature",
      searchType: null,
      width: 110,
      reachField: "exhaustTemperature"
    },
    {
      i18n: "warning.frequency",
      dataIndex: "frequency",
      searchType: null,
      width: 100,
      reachField: "frequency"
    },
    {
      i18n: "warning.ratedFrequency",
      dataIndex: "upperLimitFrequency",
      searchType: null,
      width: 110,
      reachField: "upperLimitFrequency"
    },
    {
      i18n: "warning.mainSpeed",
      dataIndex: "mainSpeed",
      searchType: null,
      width: 100,
      reachField: "mainSpeed"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  EST_AIR_FILTER_BLOCKED: [
    {
      i18n: "warning.avgFrequency",
      dataIndex: "avgFrequency",
      searchType: null,
      width: 110,
      reachField: "avgFrequency"
    },
    {
      i18n: "warning.ratedFrequency",
      dataIndex: "ratedFrequency",
      searchType: null,
      width: 130,
      reachField: "ratedFrequency"
    },
    {
      i18n: "warning.mainSpeed",
      dataIndex: "mainSpeed",
      searchType: null,
      width: 100,
      reachField: "mainSpeed"
    },
    {
      i18n: "warning.airFilterElementValue",
      dataIndex: "airFilterElementValue",
      searchType: null,
      width: 110,
      reachField: "airFilterElementValue"
    },
    {
      i18n: "warning.airFilterElementRunTime",
      dataIndex: "airFilterElementRunTime",
      searchType: null,
      width: 130,
      reachField: "airFilterElementRunTime"
    },
    {
      i18n: "warning.airFilterElementMaintainTime",
      dataIndex: "airFilterElementMaintainTime",
      searchType: null,
      width: 130,
      reachField: "airFilterElementMaintainTime"
    },
    {
      i18n: "warning.inletVacuum",
      dataIndex: "inletVacuum",
      searchType: null,
      width: 120,
      reachField: "inletVacuum"
    },
    {
      i18n: "warning.duration",
      dataIndex: "duration",
      searchType: null,
      width: 100,
      reachField: "duration"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  EST_OIL_SEPARATOR_BLOCKED: [
    {
      i18n: "warning.exhaustPressure",
      dataIndex: "exhaustPressure",
      searchType: null,
      width: 120,
      reachField: "exhaustPressure"
    },
    {
      i18n: "warning.oilDrumPressure",
      dataIndex: "oilDrumPressure",
      searchType: null,
      width: 130,
      reachField: "oilDrumPressure"
    },
    {
      i18n: "warning.outputCurrent",
      dataIndex: "outputCurrent",
      searchType: null,
      width: 100,
      reachField: "outputCurrent"
    },
    {
      i18n: "warning.frequency",
      dataIndex: "outputFrequency",
      searchType: null,
      width: 90,
      reachField: "outputFrequency"
    },
    {
      i18n: "warning.ratedFrequency",
      dataIndex: "ratedFrequency",
      searchType: null,
      width: 130,
      reachField: "ratedFrequency"
    },
    {
      i18n: "warning.mainSpeed",
      dataIndex: "mainSpeed",
      searchType: null,
      width: 130,
      reachField: "mainSpeed"
    },
    {
      i18n: "warning.oilSeparatorValue",
      dataIndex: "oilSeparatorValue",
      searchType: null,
      width: 120,
      reachField: "oilSeparatorValue"
    },
    {
      i18n: "warning.oilSeparatorRunTime",
      dataIndex: "oilSeparatorRunTime",
      searchType: null,
      width: 130,
      reachField: "oilSeparatorRunTime"
    },
    {
      i18n: "warning.oilSeparatorMaintainTime",
      dataIndex: "oilSeparatorMaintainTime",
      searchType: null,
      width: 130,
      reachField: "oilSeparatorMaintainTime"
    },
    {
      i18n: "warning.duration",
      dataIndex: "duration",
      searchType: null,
      width: 100,
      reachField: "duration"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  EST_HIGH_TEMPERATURE: [
    {
      i18n: "warning.exhaustPressure",
      dataIndex: "exhaustPressure",
      searchType: null,
      width: 120,
      reachField: "exhaustPressure"
    },
    {
      i18n: "warning.exhaustTemperature",
      dataIndex: "exhaustTemperature",
      searchType: null,
      width: 130,
      reachField: "exhaustTemperature"
    },
    {
      i18n: "warning.inletTemperature",
      dataIndex: "inletTemperature",
      searchType: null,
      width: 100,
      reachField: "inletTemperature"
    },
    {
      i18n: "warning.frequency",
      dataIndex: "outputFrequency",
      searchType: null,
      width: 90,
      reachField: "outputFrequency"
    },
    {
      i18n: "warning.ratedFrequency",
      dataIndex: "ratedFrequency",
      searchType: null,
      width: 130,
      reachField: "ratedFrequency"
    },
    {
      i18n: "warning.mainSpeed",
      dataIndex: "mainSpeed",
      searchType: null,
      width: 130,
      reachField: "mainSpeed"
    },
    {
      i18n: "warning.oilInletPressure",
      dataIndex: "oilInletPressure",
      searchType: null,
      width: 120,
      reachField: "oilInletPressure"
    },
    {
      i18n: "warning.oilInletTemperature",
      dataIndex: "oilInletTemperature",
      searchType: null,
      width: 130,
      reachField: "oilInletTemperature"
    },
    {
      i18n: "warning.temperatureValue",
      dataIndex: "temperatureValue",
      searchType: null,
      width: 130,
      reachField: "temperatureValue"
    },
    {
      i18n: "warning.oilRunTime",
      dataIndex: "oilRunTime",
      searchType: null,
      width: 140,
      reachField: "oilRunTime"
    },
    {
      i18n: "warning.oilMaintainTime",
      dataIndex: "oilMaintainTime",
      searchType: null,
      width: 140,
      reachField: "oilMaintainTime"
    },
    {
      i18n: "warning.duration",
      dataIndex: "duration",
      searchType: null,
      width: 100,
      reachField: "duration"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  EST_AIR_INLET_TEMPERATURE: [
    {
      i18n: "warning.inletTemperature",
      dataIndex: "inletTemperature",
      searchType: null,
      width: 120,
      reachField: "inletTemperature"
    },
    {
      i18n: "warning.exhaustTemperature",
      dataIndex: "exhaustTemperature",
      searchType: null,
      width: 130,
      reachField: "exhaustTemperature"
    },
    {
      i18n: "warning.mainFanInverterTemperature",
      dataIndex: "mainFanInverterTemperature",
      searchType: null,
      width: 160,
      reachField: "mainFanInverterTemperature"
    },
    {
      i18n: "warning.mainFanOutRate",
      dataIndex: "mainFanOutRate",
      searchType: null,
      width: 150,
      reachField: "mainFanOutRate"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  EST_INVERTER_HIGH_TEMPERATURE: [
    {
      i18n: "warning.exhaustPressure",
      dataIndex: "exhaustPressure",
      searchType: null,
      width: 120,
      reachField: "exhaustPressure"
    },
    {
      i18n: "warning.exhaustTemperature",
      dataIndex: "exhaustTemperature",
      searchType: null,
      width: 110,
      reachField: "exhaustTemperature"
    },
    {
      i18n: "warning.inverterTemperature",
      dataIndex: "inverterTemperature",
      searchType: null,
      width: 110,
      reachField: "inverterTemperature"
    },
    {
      i18n: "warning.outputCurrent",
      dataIndex: "outputCurrent",
      searchType: null,
      width: 100,
      reachField: "outputCurrent"
    },
    {
      i18n: "warning.inverterTemperatureValue",
      dataIndex: "inverterTemperatureValue",
      searchType: null,
      width: 130,
      reachField: "inverterTemperatureValue"
    },
    {
      i18n: "warning.runTime",
      dataIndex: "runTime",
      searchType: null,
      width: 100,
      reachField: "runTime"
    },
    {
      i18n: "warning.duration",
      dataIndex: "duration",
      searchType: null,
      width: 100,
      reachField: "duration"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  EST_FAN_BOX_OVERLOAD: [
    {
      i18n: "warning.exhaustTemperature",
      dataIndex: "exhaustTemperature",
      searchType: null,
      width: 110,
      reachField: "exhaustTemperature"
    },
    {
      i18n: "warning.inletTemperature",
      dataIndex: "inletTemperature",
      searchType: null,
      width: 110,
      reachField: "inletTemperature"
    },
    {
      i18n: "warning.motorBearingTemperature",
      dataIndex: "motorBearingTemperature",
      searchType: null,
      width: 130,
      reachField: "motorBearingTemperature"
    },
    {
      i18n: "warning.motorWindingTemperature",
      dataIndex: "motorWindingTemperature",
      searchType: null,
      width: 130,
      reachField: "motorWindingTemperature"
    },
    {
      i18n: "warning.inverterTemperatureValue",
      dataIndex: "inverterTemperatureValue",
      searchType: null,
      width: 130,
      reachField: "inverterTemperatureValue"
    },
    {
      i18n: "warning.runTime",
      dataIndex: "runTime",
      searchType: null,
      width: 100,
      reachField: "runTime"
    },
    {
      i18n: "warning.duration",
      dataIndex: "duration",
      searchType: null,
      width: 100,
      reachField: "duration"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  EST_ELECTRONIC_FAN_OVERLOAD: [
    {
      i18n: "warning.exhaustPressure",
      dataIndex: "exhaustPressure",
      searchType: null,
      width: 120,
      reachField: "exhaustPressure"
    },
    {
      i18n: "warning.exhaustTemperature",
      dataIndex: "exhaustTemperature",
      searchType: null,
      width: 110,
      reachField: "exhaustTemperature"
    },
    {
      i18n: "warning.inverterTemperature",
      dataIndex: "inverterTemperature",
      searchType: null,
      width: 110,
      reachField: "inverterTemperature"
    },
    {
      i18n: "warning.runTime",
      dataIndex: "runTime",
      searchType: null,
      width: 110,
      reachField: "runTime"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  EST_MOTOR_BEARING_HIGH_TEMPERATURE: [
    {
      i18n: "warning.exhaustPressure",
      dataIndex: "exhaustPressure",
      searchType: null,
      width: 120,
      reachField: "exhaustPressure"
    },
    {
      i18n: "warning.exhaustTemperature",
      dataIndex: "exhaustTemperature",
      searchType: null,
      width: 110,
      reachField: "exhaustTemperature"
    },
    {
      i18n: "warning.outputCurrent",
      dataIndex: "outputCurrent",
      searchType: null,
      width: 110,
      reachField: "outputCurrent"
    },
    {
      i18n: "warning.motorBearingTemperature",
      dataIndex: "motorBearingTemperature",
      searchType: null,
      width: 130,
      reachField: "motorBearingTemperature"
    },
    {
      i18n: "warning.motorWindingTemperature",
      dataIndex: "motorWindingTemperature",
      searchType: null,
      width: 130,
      reachField: "motorWindingTemperature"
    },
    {
      i18n: "warning.motorBearingTemperatureValue",
      dataIndex: "motorBearingTemperatureValue",
      searchType: null,
      width: 150,
      reachField: "motorBearingTemperatureValue"
    },
    {
      i18n: "warning.greaseRunTime",
      dataIndex: "greaseRunTime",
      searchType: null,
      width: 140,
      reachField: "greaseRunTime"
    },
    {
      i18n: "warning.greaseMaintainTime",
      dataIndex: "greaseMaintainTime",
      searchType: null,
      width: 140,
      reachField: "greaseMaintainTime"
    },
    {
      i18n: "warning.motorBearingRunTime",
      dataIndex: "motorBearingRunTime",
      searchType: null,
      width: 150,
      reachField: "motorBearingRunTime"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  EST_MOTOR_WINDING_HIGH_TEMPERATURE: [
    {
      i18n: "warning.exhaustPressure",
      dataIndex: "exhaustPressure",
      searchType: null,
      width: 120,
      reachField: "exhaustPressure"
    },
    {
      i18n: "warning.exhaustTemperature",
      dataIndex: "exhaustTemperature",
      searchType: null,
      width: 110,
      reachField: "exhaustTemperature"
    },
    {
      i18n: "warning.outputCurrent",
      dataIndex: "outputCurrent",
      searchType: null,
      width: 110,
      reachField: "outputCurrent"
    },
    {
      i18n: "warning.motorBearingTemperature",
      dataIndex: "motorBearingTemperature",
      searchType: null,
      width: 130,
      reachField: "motorBearingTemperature"
    },
    {
      i18n: "warning.motorWindingTemperature",
      dataIndex: "motorWindingTemperature",
      searchType: null,
      width: 130,
      reachField: "motorWindingTemperature"
    },
    {
      i18n: "warning.motorBearingTemperatureValue",
      dataIndex: "motorBearingTemperatureValue",
      searchType: null,
      width: 150,
      reachField: "motorBearingTemperatureValue"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  EST_COOLING_WATER_BREAK: [
    {
      i18n: "warning.exhaustPressure",
      dataIndex: "exhaustPressure",
      searchType: null,
      width: 120,
      reachField: "exhaustPressure"
    },
    {
      i18n: "warning.exhaustTemperature",
      dataIndex: "exhaustTemperature",
      searchType: null,
      width: 110,
      reachField: "exhaustTemperature"
    },
    {
      i18n: "warning.oilInletTemperature",
      dataIndex: "oilInletTemperature",
      searchType: null,
      width: 110,
      reachField: "oilInletTemperature"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  EST_LOW_OIL_INLET_PRESSURE: [
    {
      i18n: "warning.exhaustPressure",
      dataIndex: "exhaustPressure",
      searchType: null,
      width: 120,
      reachField: "exhaustPressure"
    },
    {
      i18n: "warning.exhaustTemperature",
      dataIndex: "exhaustTemperature",
      searchType: null,
      width: 110,
      reachField: "exhaustTemperature"
    },
    {
      i18n: "warning.oilDrumPressure",
      dataIndex: "oilDrumPressure",
      searchType: null,
      width: 130,
      reachField: "oilDrumPressure"
    },
    {
      i18n: "warning.oilInletPressure",
      dataIndex: "oilInletPressure",
      searchType: null,
      width: 120,
      reachField: "oilInletPressure"
    },
    {
      i18n: "warning.oilInletTemperature",
      dataIndex: "oilInletTemperature",
      searchType: null,
      width: 110,
      reachField: "oilInletTemperature"
    },
    {
      i18n: "warning.frequency",
      dataIndex: "outputFrequency",
      searchType: null,
      width: 80,
      reachField: "outputFrequency"
    },
    {
      i18n: "warning.ratedFrequency",
      dataIndex: "ratedFrequency",
      searchType: null,
      width: 110,
      reachField: "ratedFrequency"
    },
    {
      i18n: "warning.lowOilInletPressureValue",
      dataIndex: "lowOilInletPressureValue",
      searchType: null,
      width: 140,
      reachField: "lowOilInletPressureValue"
    },
    {
      i18n: "warning.oilFilterRunTime",
      dataIndex: "oilFilterRunTime",
      searchType: null,
      width: 130,
      reachField: "oilFilterRunTime"
    },
    {
      i18n: "warning.oilFilterMaintainTime",
      dataIndex: "oilFilterMaintainTime",
      searchType: null,
      width: 130,
      reachField: "oilFilterMaintainTime"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  ONE_YEAR_WITHOUT_MAINTAIN: [
    {
      i18n: "warning.maintainTimeSetting",
      dataIndex: "maintainTimeSetting",
      searchType: null,
      width: 130,
      reachField: "maintainTimeSetting"
    },
    {
      i18n: "warning.maintainTime",
      dataIndex: "maintainTime",
      searchType: null,
      width: 110,
      reachField: "maintainTime"
    },
    {
      i18n: "warning.runTime",
      dataIndex: "runTime",
      searchType: null,
      width: 130,
      reachField: "runTime"
    },
    {
      i18n: "warning.lastYearMaintainTime",
      dataIndex: "lastYearMaintainTime",
      searchType: null,
      width: 120,
      reachField: "lastYearMaintainTime"
    },
    {
      i18n: "warning.lastYearRunTime",
      dataIndex: "lastYearRunTime",
      searchType: null,
      width: 110,
      reachField: "lastYearRunTime"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  OFFLINE: [
    {
      i18n: "warning.offlineDays",
      dataIndex: "offlineDays",
      searchType: null,
      width: 80,
      reachField: "offlineDays"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  DRYER_FOREWARN: [
    {
      i18n: "warning.content",
      dataIndex: "content",
      searchType: null,
      width: 180,
      reachField: "content"
    },
    {
      i18n: "warning.value",
      dataIndex: "forewarn",
      searchType: null,
      width: 80,
      reachField: "forewarn"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  START_FREQUENTLY: [
    {
      i18n: "warning.avgFrequency",
      dataIndex: "avgOutRate",
      searchType: null,
      width: 110,
      reachField: "avgOutRate"
    },
    {
      i18n: "warning.ratedFrequency",
      dataIndex: "upperRateLimit",
      searchType: null,
      width: 110,
      reachField: "upperRateLimit"
    },
    {
      i18n: "warning.lowerLimitFrequency",
      dataIndex: "lowerRateLimit",
      searchType: null,
      width: 110,
      reachField: "lowerRateLimit"
    },
    {
      i18n: "warning.ratedPressure",
      dataIndex: "settingPressure",
      searchType: null,
      width: 120,
      reachField: "settingPressure"
    },
    {
      i18n: "warning.avgPressure",
      dataIndex: "avgPressure",
      searchType: null,
      width: 120,
      reachField: "avgPressure"
    },
    {
      i18n: "warning.avgTemperature",
      dataIndex: "avgTemperature",
      searchType: null,
      width: 100,
      reachField: "avgTemperature"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  LOAD_FREQUENTLY: [
    {
      i18n: "warning.avgFrequency",
      dataIndex: "avgOutRate",
      searchType: null,
      width: 110,
      reachField: "avgOutRate"
    },
    {
      i18n: "warning.ratedFrequency",
      dataIndex: "upperRateLimit",
      searchType: null,
      width: 110,
      reachField: "upperRateLimit"
    },
    {
      i18n: "warning.lowerLimitFrequency",
      dataIndex: "lowerRateLimit",
      searchType: null,
      width: 110,
      reachField: "lowerRateLimit"
    },
    {
      i18n: "warning.ratedPressure",
      dataIndex: "settingPressure",
      searchType: null,
      width: 120,
      reachField: "settingPressure"
    },
    {
      i18n: "warning.avgPressure",
      dataIndex: "avgPressure",
      searchType: null,
      width: 120,
      reachField: "avgPressure"
    },
    {
      i18n: "warning.avgTemperature",
      dataIndex: "avgTemperature",
      searchType: null,
      width: 100,
      reachField: "avgTemperature"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  OVER_PRESSURE: [
    {
      i18n: "warning.avgFrequency",
      dataIndex: "avgOutRate",
      searchType: null,
      width: 110,
      reachField: "avgOutRate"
    },
    {
      i18n: "warning.ratedFrequency",
      dataIndex: "upperRateLimit",
      searchType: null,
      width: 110,
      reachField: "upperRateLimit"
    },
    {
      i18n: "warning.lowerLimitFrequency",
      dataIndex: "lowerRateLimit",
      searchType: null,
      width: 110,
      reachField: "lowerRateLimit"
    },
    {
      i18n: "warning.ratedPressure",
      dataIndex: "settingPressure",
      searchType: null,
      width: 120,
      reachField: "settingPressure"
    },
    {
      i18n: "warning.avgPressure",
      dataIndex: "avgPressure",
      searchType: null,
      width: 120,
      reachField: "avgPressure"
    },
    {
      i18n: "warning.avgTemperature",
      dataIndex: "avgTemperature",
      searchType: null,
      width: 100,
      reachField: "avgTemperature"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  MOTOR_HT: [
    {
      i18n: "warning.avgMotorWindingTemp",
      dataIndex: "avgMotorWindingTemp",
      searchType: null,
      width: 160,
      reachField: "avgMotorWindingTemp"
    },
    {
      i18n: "warning.maxMotorWindingTemp",
      dataIndex: "maxMotorWindingTemp",
      searchType: null,
      width: 160,
      reachField: "maxMotorWindingTemp"
    },
    {
      i18n: "warning.avgEnvTemp",
      dataIndex: "avgEnvTemp",
      searchType: null,
      width: 130,
      reachField: "avgEnvTemp"
    },
    {
      i18n: "warning.maxEnvTemp",
      dataIndex: "maxEnvTemp",
      searchType: null,
      width: 130,
      reachField: "maxEnvTemp"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  OUT_ELECTRIC_TREND: [
    {
      i18n: "warning.avgTemperature",
      dataIndex: "avgTemperature",
      searchType: null,
      width: 100,
      reachField: "avgTemperature"
    },
    {
      i18n: "warning.avgPressure",
      dataIndex: "avgPressure",
      searchType: null,
      width: 120,
      reachField: "avgPressure"
    },
    {
      i18n: "warning.avgFrequency",
      dataIndex: "avgFrequency",
      searchType: null,
      width: 110,
      reachField: "avgFrequency"
    },
    {
      i18n: "warning.avgCurrent",
      dataIndex: "avgElectric",
      searchType: null,
      width: 110,
      reachField: "avgElectric"
    },
    {
      i18n: "warning.ratedCurrent",
      dataIndex: "ratedElectric",
      searchType: null,
      width: 110,
      reachField: "ratedElectric"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  EST_MACHINE_VIBRATION: [
    {
      i18n: "warning.avgTemperature",
      dataIndex: "avgTemperature",
      searchType: null,
      width: 100,
      reachField: "avgTemperature"
    },
    {
      i18n: "warning.avgPressure",
      dataIndex: "avgPressure",
      searchType: null,
      width: 120,
      reachField: "avgPressure"
    },
    {
      i18n: "warning.avgCurrent",
      dataIndex: "avgElectricCurrent",
      searchType: null,
      width: 110,
      reachField: "avgElectricCurrent"
    },
    {
      i18n: "warning.avgFrequency",
      dataIndex: "avgOutRate",
      searchType: null,
      width: 110,
      reachField: "avgOutRate"
    },
    {
      i18n: "warning.vibration",
      dataIndex: "vibration",
      searchType: null,
      width: 110,
      reachField: "vibration"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ],
  EST_OIL_SEPARATOR_RETURN_ERROR: [
    {
      i18n: "warning.avgTemperature",
      dataIndex: "avgTemperature",
      searchType: null,
      width: 110,
      reachField: "avgTemperature"
    },
    {
      i18n: "warning.avgPressure",
      dataIndex: "avgPressure",
      searchType: null,
      width: 120,
      reachField: "avgPressure"
    },
    {
      i18n: "warning.avgOilDrumPressure",
      dataIndex: "avgOilDrumPressure",
      searchType: null,
      width: 130,
      reachField: "avgOilDrumPressure"
    },
    {
      i18n: "warning.avgFrequency",
      dataIndex: "avgOutRate",
      searchType: null,
      width: 110,
      reachField: "avgOutRate"
    },
    {
      i18n: "warning.createdAt",
      dataIndex: "createdAt",
      searchType: null,
      width: 150,
      reachField: "createdAt"
    }
  ]
}

const privateFilterParams = {
  MAINTAIN: {}
}

let pc, pf
for (let key in privateColumns) {
  pc = privateColumns[key]
  for (let i = 0; i < pc.length; i++) {
    pf = pc[i]
    if (pf.searchType === "leaveTime") {
      privateFilterParams[key][pf.dataIndex] = {
        req: "le",
        value: ""
      }
    }
  }
}

export default {
  commonTableFields,
  commonHighlightInfo,
  commonQueryParams,
  commonFilterParams,
  commonMultipieFilterParams,
  privateColumns,
  privateFilterParams
}